import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../customTable';
import axios from 'axios';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import _ from 'lodash';

const PendingproductTable = ({setActiveStep ,options,setOptions,dateLimit,setDateLimit , rowData}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [prodData , setProdDada] = useState([])
    const dispatch = useDispatch()
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "barcode",
            headerName: "Barcode",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "code",
            headerName: "Product Code",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "item",
            headerName: "Product Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "qty",
            headerName: "Qty",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "rate",
            headerName: "Rate",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "mrp",
            headerName: "MRP",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "gst_per",
            headerName: "GST %",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "gst_amt",
            headerName: "GST Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
         
          {
  field: "stock_status",
  headerName: "Stock Status",
  renderCell: (params) => (
    <span style={{ color: 'red', fontWeight: 600 }}>
      {params.value}
    </span>
  ),
}

    ]
    const rows = _.map(prodData,(val,idx)=>({
        id: idx+1,
        sno: idx+1,
        barcode:val.barcode,
        code : val.pro_code,
        item : val.pro_name,
        qty : val.qty,
        rate: val.rate,
        mrp:val.mrp,
        gst_per :val.gst_per,
        gst_amt : val.gst_amt,
        amount :val.amount,
        stock_status :val.stock_status
      }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }

//     const getProdId = () => {
//   const getProduct = {
//     from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//     to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
//     // customer: options.customer ? options.customer.id : 0,
//     // category: options.category ? options.category.id : 0,
//     // subcategory: options.subCategory ? options.subCategory.id : 0,
//     // prodid: rowData?.id,
//     outlet_id:options.customer?.id || 0,
//   };

//   axios
//     .post(
//       "/v1/stock_verify/pending_verification_report",
//       getProduct
//     )
//     .then((res) => {
//       const lines =
//         res.data?.data?.[0]?.pending_items_lines || [];

//       setProdDada(lines);
//       setPageCount(lines.length);
//     })
//     .catch((err) => {
//       setProdDada([]);
//       dispatch(
//         setSnackbar(
//           true,
//           "error",
//           err?.response?.data?.errors?.[0]?.message || "Something went wrong"
//         )
//       );
//     });
// };
const getProdId = () => {
  if (!rowData?.docno) return; 

  axios
    .get(`/v1/stock_verify/pending_items/${rowData.docno}`)
    .then((res) => {
      const lines = res.data?.data || [];
      const count = res.data?.pending_count || 0;

      setProdDada(lines);
      setPageCount(count);
    })
    .catch((err) => {
      setProdDada([]);
      dispatch(
        setSnackbar(
          true,
          "error",
          err?.response?.data?.message || "Something went wrong"
        )
      );
    });
};
useEffect(() => {
  getProdId();
}, [rowData]);

      useEffect(() => {
        getProdId()
      },[options,dateLimit,rowData])
      console.log(rowData && rowData.id)
    return (
    <Grid>
        {/* <Grid className='text-end'>
            <Button variant="contained" onClick={() => setActiveStep("0")}>Back</Button>
        </Grid> */}
        <CustomTable props={props}/>
    </Grid>
  )
}

export default PendingproductTable